module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8684/img/global.svg"